import io from "socket.io-client";
import api from "../services/api";


class SocketWorker {
  constructor(companyId , userId) {
    // Get token from localStorage instead of api.defaults.headers
    const storedToken = localStorage.getItem("token");
    const sessionToken = storedToken ? JSON.parse(storedToken) : null;

    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.token = sessionToken
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
      SocketWorker.instance = this;

    } 

    return SocketWorker.instance;
  }

  configureSocket() {
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      transports: ["polling"],
      upgrade: false,
      pingTimeout: 60000,
      pingInterval: 25000,
      query: { userId: this.userId, token: this.token }
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", () => {
      console.log("Desconectado do servidor Socket.IO");
      this.reconnectAfterDelay();
    });

    this.socket.on("connect_error", (error) => {
      console.error("Erro de conexão Socket.IO:", error.message);
      if (error.message && error.message.includes("websocket")) {
        console.log("Detectado erro de WebSocket, forçando reconexão com polling...");
        this.forceReconnect();
      }
    });

    this.socket.on("error", (error) => {
      console.error("Erro Socket.IO:", error);
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {

    this.connect();
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // console.log(event, callback)
    this.connect();
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket.close();
      this.socket.removeAllListeners();
      this.socket = null;
      this.instance = null;
      SocketWorker.instance = null;
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {
    console.log("Forzando reconexión limpia del socket...");
    if (this.socket) {
      this.socket.disconnect();
      this.socket.close();
      this.socket.removeAllListeners();
      this.socket = null;
    }
    SocketWorker.instance = null;
    this.configureSocket();
  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;